export const globalEnv = { ...window._env };
